import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BadgesGallery from './BadgesGallery';
import './AchievementsDashboard.css';
import {
	fetchUserBadgeDetails,
	fetchWeeklyLearningStreak,
	fetchUsersXPProgress,
} from '../../services/UsersApi';

import { useSelector } from 'react-redux';
import LearningStreak from './LearningStreak.jsx';
import { set } from 'lodash';
import XPProgress from './XPProgress.jsx';
function AchievementsDashboard() {
	const { userId } = useSelector((state) => state.userDetails);
	const [badgeData, setBadgeData] = React.useState([]);
	const [streakData, setStreakData] = React.useState([]);
	const [xpProgress, setXpProgress] = React.useState([]);
	const [totalProgress, setTotalProgress] = React.useState(0);
	const [userLevel, setUserLevel] = React.useState(0);

	useEffect(() => {
		fetchData();
	}, []);
	const navigate = useNavigate();

	const handleBackClick = () => {
		navigate('/user-detail');
	};

	const fetchData = async () => {
		let result = await fetchUserBadgeDetails(userId);
		result = result?.data?.data;
		if (result) {
			setBadgeData(result);
		} else {
			setBadgeData([]);
		}

		let weeklyLearningStreak = await fetchWeeklyLearningStreak(userId);
		weeklyLearningStreak = weeklyLearningStreak?.data?.data;
		if (weeklyLearningStreak) {
			setStreakData(weeklyLearningStreak);
		} else {
			setStreakData([]);
		}

		let usersXpProgress = await fetchUsersXPProgress(userId);
		console.log('Users XP Progress: ', usersXpProgress);
		usersXpProgress = usersXpProgress?.data;
		console.log('Users XP Progress after: ', usersXpProgress);
		if (usersXpProgress && usersXpProgress.levelProgress && usersXpProgress.userLevel) {
			setXpProgress(usersXpProgress.metrics);
			setTotalProgress(usersXpProgress.levelProgress);
			setUserLevel(usersXpProgress.userLevel);
		} else {
			setXpProgress([]);
			setTotalProgress(0);
			setUserLevel(0);
		}
	};

	return (
		<div className="achievement-dashboard-container">
			<div className="glow-background" />

			{/* Desktop Back Button */}
			<button className="back-button desktop-only" onClick={handleBackClick}>
				<span className="back-symbol">←</span> Back
			</button>

			{/* Mobile Back Header */}
			<div className="mobile-header mobile-only" onClick={handleBackClick}>
				<div className="header-title-container">
					<span className="back-arrow">←</span>
					<span className="header-title">Achievements</span>
				</div>
			</div>

			<div className="achievement-charts-row">
				<h2 className="achievement-title1">KC-Based Badges Gallery</h2>

				<div className="achievement-chart-card">
					<h3 className="achievement-chart-title">
						Track your badges, streaks, and learning progress!
					</h3>
					<BadgesGallery badgeData={badgeData} />
				</div>
			</div>

			<div className="achievement-charts-row">
				<h2 className="achievement-title1">Learning Streak Tracker</h2>

				<div className="achievement-chart-card">
					<LearningStreak streakData={streakData} />
				</div>
			</div>

			<div className="achievement-charts-row">
				<h2 className="achievement-title1">Milestones and XP Leveling Achievement</h2>

				<div className="achievement-chart-card-two">
					<XPProgress
						xpProgress={xpProgress}
						totalProgress={totalProgress}
						userLevel={userLevel}
					/>
				</div>
			</div>
		</div>
	);
}

export default AchievementsDashboard;
